<template>
    <div>
        <div class="card-header d-flex justify-content-between align-items-center">
            <h5 class="text-white font-weight-bolder">{{ title }}</h5>
            <div class="header-actions">
                <button
                    class="btn btn-outline-primary btn-action"
                    data-toggle="collapse"
                    data-target="#filterReservations"
                    aria-expanded="false"
                    aria-controls="filterReservations"
                >
                    <i class="fas fa-filter"></i>
                    Filtros
                </button>
            </div>
        </div>

        <!-- Filtros colapsáveis -->
        <div
            class="collapse"
            id="filterReservations"
        >
            <div class="filters-section">
                <div class="row">
                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="branch">Filial</label>
                            <v-select
                                id="branch"
                                :options="branches"
                                label="description"
                                :reduce="(branch) => branch.id"
                                v-model="filters.branch_id"
                                placeholder="Todas as Filiais"
                                :clearable="true"
                                class="style-chooser"
                            >
                                <div slot="no-options">Nenhuma filial encontrada</div>
                            </v-select>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="costCenter">Centro de Custo</label>
                            <v-select
                                id="costCenter"
                                :options="costCenters"
                                label="erp_code"
                                :reduce="(costCenter) => costCenter.id"
                                v-model="filters.cost_center_id"
                                placeholder="Todos os Centros de Custo"
                                :clearable="true"
                                class="style-chooser"
                            >
                                <div slot="no-options">Nenhum centro de custo encontrado</div>
                            </v-select>
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="data">Data Início</label>
                            <input
                                type="date"
                                id="data"
                                v-model="filters.retreat_date"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="col-md-3">
                        <div class="form-group">
                            <label for="data">Data Fim</label>
                            <input
                                type="date"
                                id="data"
                                v-model="filters.devolution_date"
                                class="form-control"
                            >
                        </div>
                    </div>

                    <div class="col-md-12">
                        <div class="d-flex gap-2 justify-content-end">
                            <button
                                class="btn btn-secondary"
                                @click="resetFilters"
                            >
                                <i class="fas fa-eraser mr-1"></i>
                                Limpar
                            </button>

                            <button
                                class="btn btn-primary"
                                @click="getFilters"
                            >
                                <i class="fas fa-search mr-1"></i>
                                Filtrar
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import {getMessage} from "../../composables/message";

export default {

    props: {
        title: {
            type: String,
            required: true,
        },
    },

    data() {
        return {
            filters: {
                branch_id: '',
                cost_center_id: '',
                retreat_date: '',
                devolution_date: '',
            },
            costCenters: [],
            branches: [],
        }
    },

    methods: {
        resetFilters() {
            this.filters = {
                branch_id: '',
                cost_center_id: '',
                retreat_date: '',
                devolution_date: '',
            };
            this.getFilters();
        },

        getFilters() {
            const plainObject = JSON.parse(JSON.stringify(this.filters));
            this.$emit('apply-filters', plainObject);
        },

        getBranches: function () {
            const self = this;
            const api = self.$store.state.api + "branches/?paginated=false";

            self.$http
                .get(api)
                .then((response) => {
                    self.branches = response.data.data;
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },

        getCostCenters: function () {
            const self = this;
            const api = self.$store.state.api + "cost-centers/?paginated=false";

            self.$http
                .get(api)
                .then((response) => {
                    self.costCenters = [
                        {
                            id: '-1',
                            erp_code: "Veículos de locação",
                        },
                        ...response.data.data
                    ];
                })
                .catch((error) => {
                    const message = error.response.data.errors ? getMessage(error.response.data.errors) : error.response.data
                    self.$message(null, message, "error");
                });
        },
    },

    mounted() {
        this.getBranches();
        this.getCostCenters();
    },
}

</script>

<style scoped>
@import "../../assets/css/home.css";

.reservation-table-header thead th {
    background: #343a40;
    color: white;
    padding: 12px 8px;
    font-weight: 600;
    text-align: center;
    border-right: 1px solid #495057;
    white-space: nowrap;
    vertical-align: middle;
}

/* Primeira coluna do header - fica fixa à esquerda */
.reservation-table-header .vehicle-column {
    position: sticky;
    left: 0;
    z-index: 101;
    background: #343a40;
    border-right: 2px solid #6c757d;
    width: 200px;
    min-width: 200px;
    max-width: 200px;
}

/* Colunas de hora do header */
.reservation-table-header .hour-column {
    width: 80px;
    min-width: 80px;
}

/* Primeira coluna do body - fica fixa à esquerda */
.reservation-table-body .vehicle-column {
    position: sticky;
    left: 0;
    z-index: 100;
    border-right: 2px solid #dee2e6;
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    padding: 8px;
    vertical-align: middle;
    font-weight: 500;
    background: #343a40;
}

/* Seção de filtros */
.filters-section {
    background-color: #f8f9fa;
    padding: 20px;
    border-top: 1px solid #dee2e6;
}

.filters-section .form-group {
    margin-bottom: 1rem;
}

.filters-section label {
    font-weight: 600;
    color: #495057;
    margin-bottom: 0.5rem;
}

/* Botão de ação do header */
.btn-action {
    border-radius: 6px;
    font-size: 14px;
    font-weight: 500;
    padding: 8px 16px;
    transition: all 0.2s ease;
}

.btn-action:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.btn-action i {
    margin-right: 8px;
}

.card-header {
    background-color: #fff;
    border-bottom: 1px solid #dee2e6;
    padding: 1rem 1.25rem;
}

/* Ajustes para os botões de filtro */
.d-flex.gap-2 {
    gap: 0.5rem;
}

/* Responsive adjustments */
@media (max-width: 768px) {
    .home-content {
        padding: 10px;
    }

    .filters-section {
        padding: 15px;
    }

    .filters-section .row .col-md-3 {
        margin-bottom: 1rem;
    }

    .d-flex.gap-2 .btn {
        margin-bottom: 0.5rem;
    }
}

/* Customização do v-select */
.style-chooser >>> .vs__dropdown-toggle {
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 2px 6px;
    min-height: 38px;
}

.style-chooser >>> .vs__dropdown-toggle:hover {
    border-color: #80bdff;
}

.style-chooser >>> .vs__selected {
    color: #495057;
}

.style-chooser >>> .vs__search::placeholder {
    color: #6c757d;
}

.style-chooser >>> .vs__clear {
    margin-right: 8px;
}

</style>



// WEBPACK FOOTER //
// src/components/Indicators/HeaderFilter.vue